module.exports = __webpack_public_path__ + "img/zoom-in.7c7b4570.svg";